import React from 'react';

// components
import {CardBorder} from '../CardBorder';
import {Divider, Skeleton} from '@mui/joy';

// styles
import {
  CardPaymentWrapper,
  CardPaymentTop,
  CardPaymentTopLeft,
  CardPaymentBottom,
  CardPaymentBottomLeft,
  CardPaymentBottomLeftItem,
} from './CardPayment-styles';
import {Subtitle, TextSmall, TextDefault} from '../../styles';

// helpers
import {useTheme} from '@emotion/react';

/**
 * Create a skeleton card that mock the card payment item
 * @returns The skeleton card payment item
 */
function CardPaymentSkeleton() {
  const {skeleton} = useTheme();

  return (
    <CardBorder variant="grey">
      <CardPaymentWrapper>
        <CardPaymentTop>
          <CardPaymentTopLeft>
            <Subtitle>
              <Skeleton variant="text" width={skeleton.text.width.xsm} />
            </Subtitle>
            <TextSmall bold="bold">
              <Skeleton variant="text" width={skeleton.text.width.md} />
            </TextSmall>
          </CardPaymentTopLeft>
          <TextSmall bold="bold">
            <Skeleton variant="text" width={skeleton.text.width.md} />
          </TextSmall>
        </CardPaymentTop>
        <Divider />
        <CardPaymentBottom>
          <CardPaymentBottomLeft>
            <CardPaymentBottomLeftItem>
              <TextSmall>
                <Skeleton variant="text" width={skeleton.text.width.lg} />
              </TextSmall>
              <TextDefault>
                <Skeleton variant="text" width={skeleton.text.width.md} />
              </TextDefault>
            </CardPaymentBottomLeftItem>
            <CardPaymentBottomLeftItem>
              <TextSmall>
                <Skeleton variant="text" width={skeleton.text.width.md} />
              </TextSmall>
              <TextDefault>
                <Skeleton variant="text" width={skeleton.text.width.md} />
              </TextDefault>
            </CardPaymentBottomLeftItem>
          </CardPaymentBottomLeft>
        </CardPaymentBottom>
      </CardPaymentWrapper>
    </CardBorder>
  );
}

export default CardPaymentSkeleton;
